import { Facet, FacetState } from '@models';
import { BaseComponent } from '../base.component';
import { BaseFacetComponent } from '../facet-types/base-facet.component';
import defaultHtml from './facet-wrapper.component.hbs';

export class FacetWrapperComponent extends BaseComponent<Facet> {
    protected override bindEvent = undefined;
    protected override customTemplatePropertyName = 'facetWrapper';
    protected override defaultHtml = defaultHtml;

    state!: FacetState;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.data.visible) {
            return '';
        }

        const html = template({
            ...this.data,
            collapsed: this.state.collapsed ?? this.data.collapsed ?? false,
            filter: this.state.filter ?? ''
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-facet-heading]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                if (this.data?.collapsible) {
                    this.state.collapsed = !this.state.collapsed;

                    this.renderContent();
                }
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-facet-search]').forEach((e) => {
            e.addEventListener('keyup', (event: Event) => {
                const element = event.currentTarget as HTMLInputElement;
                const value = element.value?.trim();

                this.state.filter = value ? value : undefined;

                this.rebindChildElements();
            });
        });

        this.shadowRoot?.querySelectorAll<BaseFacetComponent>('[hawksearch-facet]').forEach((component) => {
            component.data = this.data;
            component.state = this.state;
        });
    }

    private rebindChildElements(): void {
        this.shadowRoot?.querySelectorAll<BaseFacetComponent>('[hawksearch-facet]').forEach((component) => {
            component.renderContent();
        });
    }
}
